import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Menu, Icon, Header, Label, Popup, List } from 'semantic-ui-react'

import RegionPopUp from '../components/common/RegionPopUp'

import utils from '../utils'

const styles = {
  removeIconMargin: {
    margin: 0,
  },

  cashoutNotification: {
    position: 'absolute',
    borderRadius: 50,
    lineHeight: '12px',
    background: "red",
    top: 15,
    fontSize: 8,
    left: 25,
  }
}

export default props => {
  const { onToggle, connection, authData, logout, cashouts, regions } = props
  const currentPath = window.location.pathname

  return (
    <Menu attached="top" size="massive" style={{ marginBottom: 30 }}>
      <Menu.Menu position="left">
        <Menu.Item onClick={onToggle}>
          <Icon name="sidebar" style={styles.removeIconMargin} />
        </Menu.Item>
      </Menu.Menu>
      {
        utils.constants.env === 'STG' &&
        <Menu.Item style={{ flex: 1, justifyContent: 'center' }}>
          <Header color="red">STAGING ENV.</Header>
        </Menu.Item>
      }
      <Menu.Menu position="right">
        {
          currentPath === '/orders' && <Popup
            hideOnScroll
            wide
            trigger={
              <Menu.Item>
                <Icon
                  name="bell"
                />
                { _.size(cashouts) > 0 && <Label style={styles.cashoutNotification}>{ _.size(cashouts) }</Label> }
              </Menu.Item>
            }
            on="click"
            position="bottom center"
          >
            <List divided relaxed>
              {
                _.map(cashouts, cashout =>
                  <List.Item style={{ padding: 10 }} key={cashout.id}>
                    {cashout.deliverer_name}
                    <span style={{ fontSize: 12, marginLeft: 10 }}>{ moment(cashout.created_at).fromNow() }</span>
                  </List.Item>
                )
              }
            </List>
          </Popup>
        }

        <Menu.Item>
          <Icon
            name="signal"
            color={connection ? 'green' : 'red'}
            style={styles.removeIconMargin}
          />
        </Menu.Item>
        <RegionPopUp
          regions={regions}
          userRegion={authData.region}
          auth={authData}
        />
        <Menu.Item onClick={logout}>
          <Icon name="log out" style={{ ...styles.removeIconMargin, marginRight: 5 }} />
          {(authData && authData.username) || 'Unknown'}
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/TopNavigation.js